module.exports = "<div class=\"ui modal\">\n    <i class=\"close icon\"></i>\n    <div class=\"header\">\n        Create new work\n    </div>\n    <div class=\"content\">\n        <div class=\"ui form\" *ngIf=\"item\">\n            <work-inputs [item]=\"item\"></work-inputs>\n        </div>\n    </div>    \n    <div class=\"actions\">\n        <div class=\"ui cancel button\">\n            Cancel\n        </div>\n        <div class=\"ui ok green right labeled icon button\">\n            Create\n            <i class=\"check icon\"></i>\n        </div>\n    </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/component/work/modal/create/work-modal-create.cmp.html
 ** module id = 406
 ** module chunks = 0
 **/